<template>
  <div :class="[rootClass, `${rootClass}--color-${color}`]">
    <i v-if="icon" :class="`fa-regular fa-${icon}`"></i>
    <input type="text" class="form-input" :placeholder="placeholder" :value="value" readonly @click="$emit('click')">
  </div>
</template>

<script>
export default {
  name: 'CustomInput',
  props: {
    id: {
      type: String,
      required: true
    },
    icon: String,
    placeholder: String,
    color: {
      type: String,
      default: 'white'
    },
    value: String
  },
  data () {
    return {
      rootClass: 'custom-input'
    }
  }
}
</script>

<style lang="scss">
.custom-input {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  color: white;

  .form-input {
    flex: 1;
    color: white;
    border: none;
    padding: 0;
    box-shadow: none;
    background-color: transparent;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 0 center;
    background-size: 16px 12px;
    min-width: 100px;
    width: 100px;

    &:focus {
      outline: 0;
    }

    &::placeholder {
      color: white;
    }
  }
}
</style>